import { render, staticRenderFns } from "./DaysSelector.vue?vue&type=template&id=5c36aea0&scoped=true"
import script from "./DaysSelector.vue?vue&type=script&lang=js"
export * from "./DaysSelector.vue?vue&type=script&lang=js"
import style0 from "./DaysSelector.vue?vue&type=style&index=0&id=5c36aea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36aea0",
  null
  
)

export default component.exports